import React, { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ApiClientConfig } from './components/ApiClientConfig';
import Layout from './components/Layout/Layout';
import { WithDataLoaded } from './pages/application-page-wrapper/WithDataLoaded';
import ErrorPage from './pages/error-page/ErrorPage';
import LegitimationLandingPage from './pages/legitimation-landing-page/LegitimationLandingPage';
import { LinkExpired } from './pages/link-expired/LinkExpired';
import { routes } from './routes';
import { TransactionStatus } from './models/data-storage.model';
import { UploadPage } from './pages/upload-page/UploadPage';
import { LegitimationResultPage } from './pages/legitimation-success-page/LegitimationResultPage';
import { LegitimationRedirectPage } from './pages/legitimation-callback/LegitimationCallback';
import { SessionTimeoutPage } from './pages/session-timeout-page/SessionTimeoutPage';
import { trackingService } from './tracking/tracking.service';

const App = (): JSX.Element => {
  React.useEffect(() => {
    trackingService.setInitialJourneyData();
  }, []);

  return (
    <BrowserRouter>
      <Suspense>
        <Layout>
          <ApiClientConfig>
            <Routes>
              <Route
                path={routes.application.legitimationLanding}
                element={
                  <WithDataLoaded permittedStatuses={[TransactionStatus.LEGITIMATION_INITIALIZED]}>
                    <LegitimationLandingPage />
                  </WithDataLoaded>
                }
              />
              <Route
                path={routes.application.upload}
                element={
                  <WithDataLoaded permittedStatuses={[TransactionStatus.LEGITIMATION_DIGITAL_CONDUCTED]}>
                    <UploadPage />
                  </WithDataLoaded>
                }
              />
              <Route
                path={routes.application.legitimationResult}
                element={
                  <WithDataLoaded
                    permittedStatuses={[TransactionStatus.LEGITIMATION_CONDUCTED, TransactionStatus.ACCEPTED]}
                  >
                    <LegitimationResultPage />
                  </WithDataLoaded>
                }
              />
              <Route path={routes.application.legitimationCallback} element={<LegitimationRedirectPage />} />
              <Route path={routes.error} element={<ErrorPage />} />
              <Route path={routes.linkExpired} element={<LinkExpired />} />
              <Route path={routes.sessionTimeout} element={<SessionTimeoutPage />} />
              <Route path="*" element={<ErrorPage />} />
            </Routes>
          </ApiClientConfig>
        </Layout>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
